import {gql} from '@apollo/client';

import {getApolloClient} from 'graphql-client/ApolloClient';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

// GraphQL: Per-table data modification summary
export const DATA_MOD_SUMMARY_BY_TABLE_QUERY = gql`
  query DataModSummaryByTableQuery($id: StrictString!) @skipAudit @engComponent(name: NOTEBOOK) {
    structuredTable(id: $id) {
      ... on StructuredTableNode {
        id
        dataModificationSummary {
          numRowsDeleted
          numCellsUpdated
          numAddedRowsSubmitted
          numColumnsAdded
          numColumnsDeleted
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

/**
 * Invalidate cached data modification summary for a specific table id.
 */
export async function invalidateDataModSummaryCacheForTable(tableApiId: string): Promise<void> {
  await getApolloClient().refetchQueries({
    updateCache(cache) {
      cache.evict({id: `StructuredTableNode:${tableApiId}`, fieldName: 'dataModificationSummary'});
    },
  });
}
